<template>
  <div style="padding: 50px">
    <v-card
      v-if="$vuetify.theme.dark == true"
      min-height="550px"
      max-height="100%"
    >
      <v-navigation-drawer permanent width="100%">
        <template v-slot:prepend>
          <v-list-item style="background-color: rgb(39, 39, 39)">
            <v-list-item-content
              @click="model = 0"
              class="mr-1"
              style="text-align: center; cursor: pointer"
            >
              <v-list-item-title @click="model = 0"
                >Legislação</v-list-item-title
              >
            </v-list-item-content>
            <v-divider vertical></v-divider>
            <v-list-item-content
              @click="model = 1"
              class="ml-5"
              style="text-align: center; cursor: pointer"
            >
              <v-list-item-title @click="model = 1"
                >Publicações</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-divider></v-divider>
        <v-list dense style="background-color: rgb(39, 39, 39); height: 99%">
          <v-carousel hide-delimiters :show-arrows="false" v-model="model">
            <v-carousel-item>
              <v-list-item
                v-for="(slide, i) in list[0]"
                :key="i"
                style="background-color: rgb(39, 39, 39)"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-if="slide.titulo != null"
                    style="color: white"
                  >
                    <p class="formato">{{ slide.formato }}</p>
                    <p class="titulo">{{ slide.titulo }}</p>
                    <p class="tamanho">{{ slide.tamanho }}</p>
                    <v-icon class="iconEye" @click="open(1, i)">mdi-eye</v-icon>
                    <v-icon class="iconDow" @click="download(1, i)"
                      >mdi-download</v-icon
                    >
                  </v-list-item-title>

                  <a id="download" href="" download />
                </v-list-item-content>
              </v-list-item>
            </v-carousel-item>

            <v-carousel-item>
              <v-list-item
                v-for="(slide, i) in list[1]"
                :key="i"
                style="background-color: rgb(39, 39, 39)"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-if="slide.titulo != null"
                    style="color: white"
                  >
                    <p class="formato">{{ slide.formato }}</p>
                    <p class="titulo">{{ slide.titulo }}</p>
                    <p class="tamanho">{{ slide.tamanho }}</p>
                    <v-icon class="iconEye" @click="open(1, i)">mdi-eye</v-icon>
                    <v-icon class="iconDow" @click="download(1, i)"
                      >mdi-download</v-icon
                    >
                  </v-list-item-title>

                  <a id="download" href="" download />
                </v-list-item-content>
              </v-list-item>
            </v-carousel-item>
          </v-carousel>
        </v-list>
      </v-navigation-drawer>
    </v-card>

    <v-card
      v-else
      style="background-color: #f2f2f2"
      min-height="550px"
      max-height="100%"
    >
      <v-navigation-drawer permanent width="100%">
        <template v-slot:prepend>
          <v-list-item style="background-color: #c4c4c4">
            <v-list-item-content
              @click="model = 0"
              class="mr-1"
              style="text-align: center; cursor: pointer"
            >
              <v-list-item-title @click="model = 0"
                >Legislação</v-list-item-title
              >
            </v-list-item-content>
            <v-divider vertical></v-divider>
            <v-list-item-content
              @click="model = 1"
              class="ml-5"
              style="text-align: center; cursor: pointer"
            >
              <v-list-item-title @click="model = 1"
                >Publicações</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-divider></v-divider>
        <v-list dense style="background-color: #f2f2f2; height: 99%">
          <v-carousel hide-delimiters :show-arrows="false" v-model="model">
            <v-carousel-item>
              <v-list-item
                v-for="(slide, i) in list[model]"
                :key="i"
                style="background-color: #f2f2f2"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-if="slide.titulo != null"
                    style="color: black"
                  >
                    <p class="formato">{{ slide.formato }}</p>
                    <p class="titulo">{{ slide.titulo }}</p>
                    <p class="tamanho">{{ slide.tamanho }}</p>
                    <v-icon
                      class="iconEye"
                      @click="open(model, i)"
                      color="black"
                      >mdi-eye</v-icon
                    >
                    <v-icon
                      class="iconDow"
                      @click="download(model, i)"
                      color="black"
                      >mdi-download</v-icon
                    >
                  </v-list-item-title>

                  <a id="download" href="" download />
                </v-list-item-content>
              </v-list-item>
            </v-carousel-item>

            <v-carousel-item>
              <v-list-item
                v-for="(slide, i) in list[model]"
                :key="i"
                style="background-color: #f2f2f2"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-if="slide.titulo != null"
                    style="color: black"
                  >
                    <p class="formato">{{ slide.formato }}</p>
                    <p class="titulo">{{ slide.titulo }}</p>
                    <p class="tamanho">{{ slide.tamanho }}</p>
                    <v-icon
                      class="iconEye"
                      @click="open(model, i)"
                      color="black"
                      >mdi-eye</v-icon
                    >
                    <v-icon
                      class="iconDow"
                      @click="download(model, i)"
                      color="black"
                      >mdi-download</v-icon
                    >
                  </v-list-item-title>

                  <a id="download" href="" download />
                </v-list-item-content>
              </v-list-item>
            </v-carousel-item>
          </v-carousel>
        </v-list>
      </v-navigation-drawer>
    </v-card>
  </div>
</template>

<script>
import content from "../../../../styles/assets/arquivos.json";
export default {
  data() {
    return {
      model: 0,
      drawer: true,
      group: null,
      url: "",
      list: [content.legislacao, content.publicacoes],
    };
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    open(number, i) {
      this.getPdfUrl(number, i);
      window.open(this.url, "_blank");
    },
    download(number, i) {
      const link = document.getElementById("download");
      this.getPdfUrl(number, i);
      link.href = this.url;
      link.click();
    },
    getPdfUrl(number, i) {
      this.url = this.list[number][i].arquivo;
    },
  },
};
</script>

<style scoped>
@media only screen and (min-width: 1777px) {
  .formato {
    float: left;
    padding-left: 5%;
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .titulo {
    float: left;
    width: 950px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tamanho {
    float: left;
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconEye {
    float: left;
    padding-right: 10px;
    cursor: pointer;
  }
  .iconDow {
    padding-right: 10px;
    cursor: pointer;
  }
}
@media only screen and (max-width: 1776px) {
  .formato {
    float: left;
    padding-left: 5%;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .titulo {
    float: left;
    width: 850px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tamanho {
    float: left;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconEye {
    float: left;
    padding-right: 10px;
    cursor: pointer;
  }
  .iconDow {
    padding-right: 10px;
    cursor: pointer;
  }
}
@media only screen and (max-width: 1480px) {
  .formato {
    float: left;
    padding-left: 5%;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .titulo {
    float: left;
    width: 650px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tamanho {
    float: left;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconEye {
    float: left;
    padding-right: 10px;
    cursor: pointer;
  }
  .iconDow {
    padding-right: 10px;
    cursor: pointer;
  }
}
@media only screen and (max-width: 1276px) {
  .formato {
    float: left;
    padding-left: 5%;
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .titulo {
    float: left;
    width: 450px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tamanho {
    float: left;
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconEye {
    float: left;
    padding-right: 10px;
    cursor: pointer;
  }
  .iconDow {
    padding-right: 10px;
    cursor: pointer;
  }
}
@media only screen and (max-width: 984px) {
  .formato {
    float: left;
    padding-left: 5%;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .titulo {
    float: left;
    width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tamanho {
    float: left;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconEye {
    float: left;
    padding-right: 10px;
    cursor: pointer;
  }
  .iconDow {
    padding-right: 10px;
    cursor: pointer;
  }
}
@media only screen and (max-width: 777px) {
  .formato {
    visibility: hidden;
    float: left;
    padding-left: 5%;
    width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .titulo {
    float: left;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tamanho {
    float: left;
    width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconEye {
    float: left;
    padding-right: 10px;
    cursor: pointer;
  }
  .iconDow {
    padding-right: 10px;
    cursor: pointer;
  }
}

@media only screen and (max-width: 535px) {
  .formato {
    visibility: hidden;
    float: left;
    padding-left: 5%;
    width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .titulo {
    float: left;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tamanho {
    visibility: hidden;
    float: left;
    width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconEye {
    float: left;
    padding-right: 10px;
    cursor: pointer;
  }
  .iconDow {
    padding-right: 10px;
    cursor: pointer;
  }

  v::deep .v-navigation-drawer__content {
    overflow: hidden;
  }
}
</style>
